import React from 'react';
import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { format } from 'date-fns';

const getActionColor = (action) => {
  switch (action.toLowerCase()) {
    case 'login':
      return 'primary';
    case 'create':
      return 'success';
    case 'update':
      return 'info';
    case 'delete':
      return 'error';
    case 'search':
      return 'secondary';
    case 'view':
      return 'default';
    default:
      return 'default';
  }
};

const RecentActivityTable = ({ activities = [] }) => {
  if (activities.length === 0) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No recent activity found
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} elevation={0} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Time</TableCell>
            <TableCell>User</TableCell>
            <TableCell>Action</TableCell>
            <TableCell>Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {activities.map((activity, index) => (
            <TableRow key={activity.id || index} hover>
              <TableCell>
                {activity.timestamp ? 
                  format(new Date(activity.timestamp), 'MMM dd, HH:mm:ss') : 
                  'N/A'}
              </TableCell>
              <TableCell>{activity.username || 'Anonymous'}</TableCell>
              <TableCell>
                <Chip 
                  label={activity.action || 'Unknown'} 
                  size="small" 
                  color={getActionColor(activity.action || '')}
                  variant="outlined"
                />
              </TableCell>
              <TableCell>
                <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
                  {activity.details || 'No details provided'}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RecentActivityTable;